export const AFFILIATE_CREATE = "AFFILIATE_CREATE";
export const AFFILIATE_CREATE_FAILURE = "AFFILIATE_CREATE_FAILURE";
export const AFFILIATE_CREATE_SUCCESS = "AFFILIATE_CREATE_SUCCESS";
export const AFFILIATE_LOGIN = "AFFILIATE_LOGIN";
export const AFFILIATE_LOGIN_FAILURE = "AFFILIATE_LOGIN_FAILURE";
export const AFFILIATE_LOGIN_SUCCESS = "AFFILIATE_LOGIN_SUCCESS";
export const AFFILIATE_LOGOUT = "AFFILIATE_LOGOUT";
export const GET_AFFILIATE_PROFILE = "GET_AFFILIATE_PROFILE";
export const GET_AFFILIATE_PROFILE_SUCCESS = "GET_AFFILIATE_PROFILE_SUCCESS";
export const GET_AFFILIATE_PROFILE_FAILURE = "GET_AFFILIATE_PROFILE_FAILURE";

export const GET_AFFILIATE_ORDERS = "GET_AFFILIATE_ORDERS";
export const GET_AFFILIATE_ORDERS_SUCCESS = "GET_AFFILIATE_ORDERS_SUCCESS";
export const GET_AFFILIATE_ORDERS_FAILURE = "GET_AFFILIATE_ORDERS_FAILURE";

export const GET_AFFILIATE_ORDERS_COUNT = "GET_AFFILIATE_ORDERS_COUNT";
export const GET_AFFILIATE_ORDERS_COUNT_SUCCESS = "GET_AFFILIATE_ORDERS_COUNT_SUCCESS";
export const GET_AFFILIATE_ORDERS_COUNT_FAILURE = "GET_AFFILIATE_ORDERS_COUNT_FAILURE";

export const AFFILIATE_FORGOT_PASSWORD = "AFFILIATE_FORGOT_PASSWORD";
export const AFFILIATE_FORGOT_PASSWORD_SUCCESS = "AFFILIATE_FORGOT_PASSWORD_SUCCESS";
export const AFFILIATE_FORGOT_PASSWORD_FAILURE = "AFFILIATE_FORGOT_PASSWORD_FAILURE";

export const AFFILIATE_RESET_PASSWORD = "AFFILIATE_RESET_PASSWORD";
export const AFFILIATE_RESET_PASSWORD_SUCCESS = "AFFILIATE_RESET_PASSWORD_SUCCESS";
export const AFFILIATE_RESET_PASSWORD_FAILURE = "AFFILIATE_RESET_PASSWORD_FAILURE";
